import { render, staticRenderFns } from "./ReviewMaid.vue?vue&type=template&id=8cc96fe8&scoped=true"
import script from "./ReviewMaid.vue?vue&type=script&lang=js"
export * from "./ReviewMaid.vue?vue&type=script&lang=js"
import style0 from "./ReviewMaid.vue?vue&type=style&index=0&id=8cc96fe8&prod&lang=css"
import style1 from "./ReviewMaid.vue?vue&type=style&index=1&id=8cc96fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc96fe8",
  null
  
)

export default component.exports